import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FormatListBulletedSharpIcon from "@mui/icons-material/FormatListBulletedSharp";
import { Grid2, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

type Props = {
	setId?: (id: number) => void;
	url?: string;
	id?: number;
	edit: boolean;
	showDelete?: boolean;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: () => void;
};

export const GridButtons = ({
	setId = () => {},
	url = "",
	id = -1,
	edit = true,
	showDelete = false,
	setShowModal,
	showContextMenu,
}: Props) => {
	const navigate = useNavigate();

	return (
		<Grid2
			container
			sx={{
				height: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				opacity: 0,
				transition: "opacity 0.1s ease-in-out",
				"& .ag-row-hover": {
					opacity: 1,
				},
				"& .ag-row-focus": {
					opacity: 1,
				},
				"& .ag-row-selected": {
					opacity: 1,
				},
			}}
			className={`buttons`}
		>
			<Grid2
				size={{ md: 12, xs: 12 }}
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					gap: "1rem",
				}}
			>
				{edit && (
					<IconButton
						onClick={() => {
							setId(id);
							setShowModal("update");
							navigate(url);
						}}
						title="Edit"
						size="small"
					>
						<EditIcon style={{ height: "auto" }} color="primary" />
					</IconButton>
				)}
				{showDelete && (
					<IconButton
						onClick={() => {
							setId(id);
							setShowModal("delete");
						}}
						title="Delete"
						size="small"
					>
						<DeleteIcon style={{ height: "auto" }} color="secondary" />
					</IconButton>
				)}
				<IconButton onClick={showContextMenu} title="Options" size="small">
					<FormatListBulletedSharpIcon
						style={{ height: "auto" }}
						color="action"
					/>
				</IconButton>
			</Grid2>
		</Grid2>
	);
};
